<template>
  <div id="index" class="index">
    <clickRightMenu ref="echartsRightMenu"></clickRightMenu>
    <div class="indexBg" @click="goLogin" v-show="indexBgShow"></div>

    <!-- 引入header头部组件-start -->
    <headerBar :headerActiveIndex="pageHeaderActiveIndex" ref="headerBar"></headerBar>
    <!-- 引入header头部组件-end -->
    <div class="headerHight"></div>

    <!-- 搜索-start -->
    <div class="pageSearch">
      <div class="searchCon">
        <div class="searchInput">
          <input type="text" placeholder="请输入你的产品关键词，多个词请用空格隔开" class="keyWord" v-model="indexKeyWord"
            @keyup.enter="setParams" />
          <!-- @input="keyWordListShow" -->
          <a href="javascript:;" class="searchTipsBtn" @click="searchTipsShow">
            <img src="@/page/tender/img/tipsIco.png" />
          </a>
          <a href="javascript:;" class="searchBtn" @click="setParams">搜索</a>
          <!-- 公司关联下拉-start -->
          <div class="keyWordList" v-show="keyWordListStatus" v-click-outside="keyWordListHide">
            <ul>
              <li v-for="(item, index) in keyWordList" v-bind:key="index" @click="companyNameSet(item.searchValue)">
                {{ item.searchValue }}
              </li>
            </ul>
          </div>
          <!-- 公司关联下拉-end -->
          <!-- 搜索说明-start -->
          <div class="searchTips" v-show="searchTipsStatus">
            <em>
              <img src="@/common/img/searchTopBtn1.png" />
            </em>
            <div class="tipsCon">
              <!-- 多个关键字组合搜索，可输入： “关键词1+关键词2 关键词3 -关键词4 关键词5/关键词6”
              空格和+均表示关键词间关系为 “和”
              /表示关键词间的关系为“或”
              -表示排除指定关键词（减号前需加空格） -->

              <span>搜索关键词更新说明：</span>
              <br />
              1）空格和"+"均表示"且"，"/"表示"或"，" -"表示排除特定关键字;<br />
              2）支持一个或多个关键字组合，如"关键词 关键词 -关键词"，"关键字+关键字/关键字+关键字 -关键字"...等("-"减号前需加空格，可多个);
            </div>
          </div>
          <!-- 搜索说明-end -->
        </div>
        <div class="hotSearch">
          <span>热门搜索：</span>
          <ul>
            <li v-for="hotKeywordVal in hotKeywordList" v-bind:key="hotKeywordVal"
              @click="sethotKeywordParams(hotKeywordVal)">
              {{ hotKeywordVal }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 搜索-end -->

    <!-- echarts-图表-start -->
    <div class="echartList">
      <el-carousel :interval="5000" arrow="always" :autoplay="false">
        <el-carousel-item>
          <div class="communicationEchart echartsCon">
            <div class="title"><em>通信</em>标讯统计</div>
            <div class="time">{{ startTime }} - {{ endTime }}</div>
            <div class="dataShow">
              <div class="tenderData">
                项目数量
                <div class="tenderDataNum">
                  {{ echartList.tongxin.totalProject }}
                </div>
              </div>
              <div class="tenderMoney">
                项目金额
                <div class="tenderMoneyNum">
                  ¥{{ echartList.tongxin.totalMoney | numFilter }}
                </div>
              </div>
            </div>

            <div class="cl_f"></div>
            <div class="echartShowDiv">
              <div class="echartLeft">
                <div id="indexLineEchart_tongxin"></div>
              </div>
              <div class="echartRight">
                <div class="echartRightDiv">
                  <div id="indexPieEchart_tongxin"></div>
                  <div class="indexPieList">
                    <ul>
                      <li v-for="item in indexPieList" v-bind:key="item.id">
                        <div class="name">
                          <em></em>
                          {{ item.name }}
                        </div>
                        <div class="numList">
                          <div class="listDiv">
                            <span>{{ item.totalMoney | numFilter }}</span>
                          </div>
                          <div class="listDiv">
                            <span>{{ item.count }}</span>
                          </div>
                          <div class="listDiv">
                            <span>{{ item.proportion }}%</span>
                          </div>
                        </div>
                        <div class="cl_f"></div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- echartRight-end -->
            </div>
          </div>
          <!-- 通信标讯统计-end -->
          <div class="cl_f"></div>
        </el-carousel-item>
        <!-- 通信标讯统计-end -->
        <el-carousel-item>
          <div class="electricityEchart echartsCon">
            <div class="title"><em>电力</em>标讯统计</div>
            <div class="time">{{ dianLiStartTime }} - {{ dianLiEndTime }}</div>
            <div class="dataShow">
              <div class="tenderData">
                项目数量
                <div class="tenderDataNum">
                  {{ echartList.dianli.totalProject }}
                </div>
              </div>
              <div class="tenderMoney">
                项目金额
                <div class="tenderMoneyNum">
                  ¥{{ echartList.dianli.totalMoney | numFilter }}
                </div>
              </div>
            </div>
            <div class="cl_f"></div>
            <div class="echartShowDiv">
              <div class="echartLeft">
                <div id="indexLineEchart_dianli"></div>
              </div>
              <div class="echartRight">
                <div class="echartRightDiv">
                  <div id="indexPieEchart_dianli"></div>
                  <div class="indexPieList">
                    <ul>
                      <li v-for="item in dainLiPieList" v-bind:key="item.id">
                        <div class="name">
                          <em></em>
                          {{ item.name }}
                        </div>
                        <div class="numList">
                          <div class="listDiv">
                            <span>{{ item.totalMoney | numFilter }}</span>
                          </div>
                          <div class="listDiv">
                            <span>{{ item.count }}</span>
                          </div>
                          <div class="listDiv">
                            <span>{{ item.proportion }}%</span>
                          </div>
                        </div>
                        <div class="cl_f"></div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 电力标讯统计-end -->
          <div class="cl_f"></div>
        </el-carousel-item>
        <!-- 电力标讯统计-end -->

        <el-carousel-item>
          <div class="governmentEchart echartsCon">
            <div class="title"><em>政府</em>标讯统计</div>
            <div class="time">
              {{ governmentStartTime }} - {{ governmentEndTime }}
            </div>
            <div class="dataShow">
              <div class="tenderData">
                项目数量
                <div class="tenderDataNum">
                  {{ echartList.government.totalProject }}
                </div>
              </div>
              <div class="tenderMoney">
                项目金额
                <div class="tenderMoneyNum">
                  ¥{{ echartList.government.totalMoney | numFilter }}
                </div>
              </div>
            </div>
            <div class="cl_f"></div>
            <div class="echartShowDiv">
              <div class="echartLeft">
                <div id="indexLineEchart_government"></div>
              </div>
              <div class="echartRight">
                <div class="echartRightDiv">
                  <div id="indexPieEchart_government"></div>
                  <div class="indexPieList">
                    <ul>
                      <li v-for="item in governmentPieList" v-bind:key="item.id">
                        <div class="name">
                          <em></em>
                          {{ item.name }}
                        </div>
                        <div class="numList">
                          <div class="listDiv">
                            <span>{{ item.totalMoney | numFilter }}</span>
                          </div>
                          <div class="listDiv">
                            <span>{{ item.count }}</span>
                          </div>
                          <div class="listDiv">
                            <span>{{ item.proportion }}%</span>
                          </div>
                        </div>
                        <div class="cl_f"></div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 政府标讯统计-end -->
          <div class="cl_f"></div>
        </el-carousel-item>
        <!-- 政府标讯统计-end -->
      </el-carousel>
    </div>
    <!-- echarts-图表-end -->
    <div class="indexMargin"></div>
    <div class="indexPart2">
      <div class="indexLabel">
        <div class="label">
          <div class="labelTitle">通信</div>
          <ul>
            <li v-for="(item, index) in businessType" v-bind:key="index" v-on:click="typeChoose(1, index)">
              {{ item.name }}
            </li>
          </ul>
          <div class="cl_f"></div>
        </div>
        <div class="label">
          <div class="labelTitle">政府</div>
          <ul>
            <li v-for="(item, index) in jobType" v-bind:key="index" v-on:click="typeChoose(3, index)">
              {{ item.name }}
            </li>
          </ul>
          <div class="cl_f"></div>
        </div>
        <div class="label">
          <div class="labelTitle">电力</div>
          <ul>
            <li v-for="(item, index) in electricityType" v-bind:key="index" v-on:click="typeChoose(2, index)">
              {{ item.name }}
            </li>
          </ul>
          <div class="cl_f"></div>
        </div>
      </div>
      <div class="recentZtbList">
        <div class="pageTabNav">
          <el-tabs v-model="activeName1">
            <el-tab-pane label="推荐标讯" name="first"></el-tab-pane>
          </el-tabs>
          <router-link to="/tender/hotTender" v-if="(hotTenderList != null) & (hotTenderList.length > 0)">
            <a href="#" class="moreBtn">更多</a>
          </router-link>
        </div>
        <!-- 招投标列表组件-start -->
        <div v-if="indexBgShow == false">
          <div v-loading="hotTenderLoading" element-loading-text="拼命加载中">
            <div class="hotTenderList" v-for="item in hotTenderList" v-bind:key="item.id"
              @click="setTenderIdParams(item.id)">
              <ztbList :ztbStatus="item.ztbType == 1 ? '招' : '中'" :ztbStatusShow="item.ztbType == null ? false : true"
                :ztbTitle="item.pageTitle" :ztbMoney="item.projectAmount | numFilter" :ztbMoneyShow="item.projectAmount == null ||
                  item.projectAmount == 0 ||
                  item.projectAmount < 0.01
                  ? false
                  : true
                  " :ztbType="item.businessType" :ztbTypeShow="item.businessType == null ? false : true"
                :ztbTSource="item.areaOperation | updateSiteName(item)"
                :ztbTSourceShow="item.provinceName || item.siteName" :ztbTime="item.purchaseDate | formatDate"
                :ztbTimeShow="item.purchaseDate == null ? false : true">
              </ztbList>
            </div>
            <!-- 招投标列表组件-end -->
            <div class="resultNull" v-show="hotTenderNull">
              <img src="@/common/img/null.png" />
            </div>
          </div>
        </div>
        <div class="hotTenderTips" v-if="indexBgShow == true">
          <div class="resultNull">
            <img src="@/common/img/null.png" />
          </div>
          <p>推荐标讯需要登录才可查看</p>
        </div>
      </div>
    </div>

    <!-- 首页banner图-start -->
    <div class="bannerImg" v-show="bannerImgShow">
      <a target="_blank" :href="bannerImgLink">
        <img :src="bannerImgUrl" />
      </a>
    </div>
    <!-- 首页banner图-end -->

    <div class="ztbNavType">
      <div class="pageTabNav">
        <el-tabs v-model="tenderTypeActive" @tab-click="handleClick">
          <el-tab-pane label="近期大标" name="first"></el-tab-pane>
          <el-tab-pane label="中标公告" name="second"></el-tab-pane>
          <el-tab-pane label="招标公告" name="third"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="tenderSecondType">
        <a href="javascript:;" v-for="item in tenderSecondTypeList" v-bind:key="item.id" @click="selectSecondType(item)"
          :class="item.status == 1 ? 'active' : ''">{{ item.name }}</a>
      </div>
      <div class="ztbNavResult">
        <!-- 招投标列表组件-start -->
        <div v-loading="tenderTypeLoading" element-loading-text="拼命加载中">
          <div class="tenderTypeList" v-for="item in tenderTypeList" v-bind:key="item.id" :data="tenderTypeList"
            @click="setTenderIdParams(item.id)">
            <ztbList :ztbStatus="item.ztbType == 1 ? '招' : '中'" :ztbStatusShow="item.ztbType == null ? false : true"
              :ztbTitle="item.pageTitle" :ztbMoney="item.projectAmount | numFilter" :ztbMoneyShow="item.projectAmount == null ||
                item.projectAmount == 0 ||
                item.projectAmount < 0.01
                ? false
                : true
                " :ztbType="item.businessType" :ztbTypeShow="item.businessType == null ? false : true"
              :ztbTSource="item.areaOperation | updateSiteName(item)" :ztbTSourceShow="item.provinceName || item.siteName"
              :ztbTime="item.purchaseDate | formatDate" :ztbTimeShow="item.purchaseDate == null ? false : true"></ztbList>
          </div>
          <div class="resultNull" v-show="tenderTypeNull">
            <img src="@/common/img/null.png" />
          </div>
        </div>
        <!-- 招投标列表组件-end -->
      </div>
      <!-- 分页-start -->
      <div class="pageFy" v-show="tenderTypePageFy">
        <el-pagination @size-change="handleSizeChange" @current-change="current_change" :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40, 50]" :page-size="20" background layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"></el-pagination>
      </div>
      <!-- 分页-end -->
    </div>

    <!-- 引入footer底部组件-start -->
    <footerBar></footerBar>
    <!-- 引入footer底部组件-end -->

    <!-- 引入二维码登录组件-start -->
    <ewmLogin :isLogin="isLogin" ref="ewmLogin"></ewmLogin>
    <!-- 引入二维码登录组件-end -->

    <!-- 引入业务订阅组件-start -->
    <businessSubscription v-if="showBusinessSub" ref="businessSubscriptionPart"></businessSubscription>
    <!-- 引入业务订阅组件-end -->

    <div class="visibleHui">
      <el-dialog width="30%" :visible.sync="visibleHui" :lock-scroll="false">
        <img style="width: 18vw;height: 50vh;" src="https://umxh.xue2you.cn/file/80.png " />
      </el-dialog>
    </div>



  </div>
</template>

<script>
// 自定义组件components
import headerBar from "@/components/header/header.vue"; // 顶部导航部组件
import ztbList from "@/components/ztbList/ztbList.vue"; // 招投标列表组件
import footerBar from "@/components/footer/footer.vue"; // 底部导航组件
import ewmLogin from "@/components/ewmLogin/ewmLogin.vue"; //二维码登录组件
import phoneLogin from "@/components/phoneLogin/phoneLogin.vue"; //手机登录组件
import businessSubscription from "@/components/businessSubscription/businessSubscription.vue"; //业务订阅组件
import clickRightMenu from "../components/tool/echarts/clickRightMenu.vue";//图表右击事件
//封装的js
import { base } from "@/common/js/base"; //公共js
import { pageParam } from "@/common/js/pageParam"; //获取页面参数js
import { lineEchart } from "@/common/js/lineEchart"; //折线图柱状图混合js
import { pieEchart } from "@/common/js/pieEchart"; //饼状图js

import { throws } from "assert";

export default {
  // 注册组件（组件必须要先注册才可使用）
  components: {
    headerBar, // 顶部导航部组件
    ztbList, // 招投标列表组件
    footerBar, // 底部导航组件
    ewmLogin, //二维码登录组件
    phoneLogin, //手机登录组件
    businessSubscription, //业务订阅组件
    clickRightMenu
  },
  name: "index",
  data() {
    return {
      visibleHui: false,
      loginShow: false,
      pageHeaderActiveIndex: "1", //设置头部导航选状态
      activeName1: "first",
      tenderTypeActive: "first", //推荐标讯、中标标讯、招标标讯选中状态，默认选中推荐标讯
      hotKeywordList: [], // 热门搜索关键字
      hotTenderList: [], // 近期大标列表
      tenderTypeList: [], // 推荐标讯、中标、招标列表
      echartList: {
        // 统计数据
        dianli: {},
        tongxin: {},
        government: {}
      },
      hotTenderLoading: true, //推荐标讯列表加载中
      hotTenderNull: false, //推荐标讯列表是否为空
      tenderTypeLoading: true,
      tenderTypeNull: false,
      tenderTypePageFy: false,
      totalCount: 0, //默认数据总数
      pageSize: 20, //每页的数据条数
      currentPage: 1, //默认开始页面
      ztbType: 1, //招投标的类型；0 全部 , 1 招标公告 , 2 中标公告
      indexPieList: [], //数据分析-通信运营商列表
      dainLiPieList: [], //数据分析-电力运营商列表
      governmentPieList: [], //数据分析-政府职能标签列表
      startTime: "", //数据分析-通信开始时间
      endTime: "", //数据分析-通信结束时间
      dianLiStartTime: "", //数据分析-电力开始时间
      dianLiEndTime: "", //数据分析-电力结束时间
      governmentStartTime: "", //数据分析-政府开始时间
      governmentEndTime: "", //数据分析-政府结束时间
      isLogin: false, //是否要二维码登录
      bannerImgShow: false, //首页广告默认显示
      bannerImgLink: "", //首页广告图跳转的链接
      bannerImgUrl: "", //首页广告图地址
      indexKeyWord: "", //搜索的关键字
      businessType: [], //通信-业务类型
      industryType: [
        { name: "通信", id: 1, state: 0 },
        { name: "电力", id: 2, state: 0 },
        { name: "政府", id: 3, state: 1 }
      ], //行业类型
      jobTabType: [], //政府-职能标签
      jobType: [],
      electricityType: [], //电力-行业分类
      searchTipsStatus: false, //搜索说明-隐藏
      keyWordListStatus: false, //公司关联
      keyWordList: [], //公司关联列表
      isPhoneLoginLayShow: false, //手机登录
      // 是否显示业务订阅
      showBusinessSub: false,
      tenderSecondTypeList: [
        { name: "全部", id: "", status: 1 },
        { name: "通信", id: 1, status: 0 },
        { name: "电力", id: 2, status: 0 },
        { name: "政府", id: 3, status: 0 }
      ],
      guildId: "", //行业类型
      indexBgShow: true
    };
  },

  /**
   * 过滤器
   */
  filters: {
    // 时间戳转日期
    formatDate: function (value) {
      return new base().formatDate(value);
    },

    // 截取当前数据到小数点后两位，小数点后两位为0就直接去掉
    numFilter: function (value) {
      return new base().numFilter(value);
    }
  },
  methods: {
    //选择行业类型
    selectSecondType(item) {
      var that = this;
      that.tenderSecondTypeList.forEach(e => {
        e.status = 0;
      });
      item.status = 1;
      that.guildId = item.id;
      if (that.tenderTypeActive == "first") {
        this.getBigTenderList(); //加载近期大标列表
      } else if (that.tenderTypeActive == "second") {
        this.getZtbTenderList(); //加载中标列表
      } else if (that.tenderTypeActive == "third") {
        this.getZtbTenderList(); //加载招标列表
      }
    },

    //搜索关键字跳转-携带参数
    setParams() {
      var that = this;
      if (that.isLogin == true) {
        var ewmLogin = that.$refs.ewmLogin;
        if (ewmLogin != null) {
          ewmLogin.showLogin();
        }
        return;
      }
      that.$router.push({
        path: "/tender/search", //跳转的路由
        query: {
          dataObj: that.indexKeyWord //参数对象
        }
      });
    },

    //热门关键字跳转-携带热门关键字
    sethotKeywordParams(val) {
      var that = this;
      if (that.isLogin == true) {
        var ewmLogin = that.$refs.ewmLogin;
        if (ewmLogin != null) {
          ewmLogin.showLogin();
        }
        return;
      }
      that.$router.push({
        path: "/tender/search", //跳转的路由
        query: {
          dataObj: val //参数对象
        }
      });
    },

    //标讯列表跳转-携带id
    setTenderIdParams(id) {
      console.log("标讯列表id:" + id);
      var that = this;
      if (that.isLogin == true) {
        var ewmLogin = that.$refs.ewmLogin;
        if (ewmLogin != null) {
          ewmLogin.showLogin();
        }
        return;
      }
      const { href } = that.$router.resolve({
        path: "/tender/tenderDetail", //跳转的路由-标讯详情页
        query: {
          dataObj: id //参数对象
        }
      });
      window.open(href, "_blank");
    },

    //搜索说明
    searchTipsShow: function () {
      var that = this;
      if (that.searchTipsStatus == false) {
        that.searchTipsStatus = true;
      } else {
        that.searchTipsStatus = false;
      }
    },

    //公司下拉关联
    keyWordListShow: function () {
      let that = this;
      if (that.indexKeyWord == null || that.indexKeyWord == "") {
        that.keyWordListStatus = false;
        return;
      }

      let tmpSearchContent = that.indexKeyWord;

      that.requestApi({
        method: "get",
        // url: "/api/company/likeCompanyName",
        // data: {
        //   companyName: that.searchKeyWord
        // },
        url: "/api/ztb/info/listByValue",
        data: {
          value: that.indexKeyWord
        },
        then(data) {
          // 方式异步加载导致关键字顺序不一致
          if (tmpSearchContent !== that.indexKeyWord) {
            return;
          }

          if (data.data != null) {
            that.keyWordListStatus = true;
            that.keyWordList = data.data;
          } else {
            that.keyWordListStatus = false;
          }
        }
      });
    },

    /**
     * 搜索框失去焦点将公司关联隐藏
     */
    keyWordListHide: function () {
      var that = this;
      that.keyWordListStatus = false;
    },

    /**
     * 选择关联的公司
     */
    companyNameSet: function (companyName) {
      var that = this;
      that.indexKeyWord = companyName; //将下拉选择的内容回显在搜索输入框
      that.setParams(); //搜索关键字跳转-携带参数
    },

    //近期大标、中标标讯、招标标讯选择
    handleClick(tab) {
      //选择-近期大标
      if (tab.name == "first") {
        this.currentPage = 1;
        this.getBigTenderList();
      }
      //选择-中标标讯
      if (tab.name == "second") {
        this.ztbType = 2;
        this.currentPage = 1;
        this.getZtbTenderList();
      }
      //选择-招标标讯
      if (tab.name == "third") {
        this.ztbType = 1;
        this.currentPage = 1;
        this.getZtbTenderList();
      }
    },

    /**
     * 获取热门搜索关键字
     */
    getHotQueryKeyword() {
      let that = this;
      that.requestApi({
        method: "get",
        url: "/api/hotSearch/listHotSearch",
        data: {
          companyName: that.indexKeyWord
        },
        then(data) {
          if (data.data != null) {
            that.hotKeywordList = data.data;
          }
        }
      });
    },

    /**
     * 获取近期大标列表
     */
    getBigTenderList: function () {
      var that = this;
      that.tenderTypeLoading = true; //显示加载中
      that.tenderTypeNull = false; //结果为空--隐藏
      that.tenderTypeList = []; //将近期大标列表数据清空
      that.tenderTypePageFy = false; //分页隐藏
      that.requestApi({
        method: "get",
        url: "/api/ztb/info/listVastProjectMoney",
        data: {
          pageIndex: that.currentPage,
          pageSize: that.pageSize,
          keyword: "",
          guildId: that.guildId //行业类型
        },
        then(data) {
          that.loginShow = true;
          if ((data.data != null) & (data.data.length > 0)) {
            that.tenderTypeNull = false; //结果为空--隐藏
            that.tenderTypeLoading = false; //加载中消失
            that.tenderTypeList = data.data; //获取近期大标列表
            that.totalCount = data.count; //获取总页数
            that.tenderTypePageFy = true; //分页显示
          } else {
            that.tenderTypeLoading = false; //加载中消失
            that.tenderTypePageFy = false; //分页隐藏
            that.tenderTypeNull = true; //结果为空--显示
            that.tenderTypeList = []; //清空近期大标列表
          }
        }
      });
    },

    /**
     * 获取推荐标讯列表
     */
    getRecommendTenderList: function () {
      var that = this;
      console.log("that.isLogin:" + that.isLogin);
      if (that.isLogin == true) {
        that.hotTenderLoading = false; //加载中消失
        that.hotTenderNull = true; //结果为空--显示
        return;
      }
      that.hotTenderLoading = true; //显示加载中
      that.hotTenderNull = false; //结果为空--隐藏
      that.hotTenderList = []; //将推荐标讯列表数据清空
      that.requestApi({
        method: "get",
        url: "/api/user/userTag/userTagInfos",
        data: {
          pageIndex: 1,
          pageSize: 5
        },
        then(data) {
          that.loginShow = true;
          if ((data.data != null) & (data.data.length > 0)) {
            that.hotTenderLoading = false; //加载中消失
            that.hotTenderNull = false; //结果为空--隐藏
            that.hotTenderList = data.data; //获取推荐标讯列表
          } else {
            that.hotTenderLoading = false; //加载中消失
            that.hotTenderNull = true; //结果为空--显示
            that.hotTenderList = []; //清空推荐标讯列表
          }
        }
      });
    },

    /**
     * 获取招标、中标列表
     */
    getZtbTenderList: function () {
      var that = this;
      that.tenderTypeLoading = true; //显示加载中
      that.tenderTypeNull = false; //结果为空--隐藏
      that.tenderTypeList = []; //将推荐标讯列表数据清空
      that.tenderTypePageFy = false; //分页隐藏
      that.requestApi({
        method: "get",
        url: "/api/ztb/info/getInfoByInfoVO",
        data: {
          pageIndex: that.currentPage,
          pageSize: that.pageSize,
          type: that.ztbType,
          guildId: that.guildId
        },
        then(data) {
          if (data.data != null) {
            that.tenderTypeNull = false; //结果为空--隐藏
            that.tenderTypeLoading = false; //加载中消失
            that.tenderTypeList = data.data; //获取招标、中标列表
            that.totalCount = data.pageInfo.pageCount; //分页的总页数
            that.tenderTypePageFy = true; //分页显示
          } else {
            that.tenderTypeLoading = false; //加载中消失
            that.tenderTypePageFy = false; //分页隐藏
            that.tenderTypeNull = true; //结果为空--显示
            that.tenderTypeList = []; //清空招标、中标列表
          }
        }, fail(error) {
          if (error.data.code == -2) {
            // that.$message.error('非VIP会员3次/天搜索次数已用完，可开通会员畅享使用');
            // that.$router.push({name: 'index', params: {getInfoByInfoVOKey: -2}});
          }
        }
      });
    },

    /**
     * 获取当前点击的分页
     */
    current_change: function (currentPage) {
      console.log("currentPage:" + currentPage);
      var that = this;
      that.currentPage = currentPage;
      if (that.tenderTypeActive == "first") {
        this.getBigTenderList(); //加载近期大标列表
      } else if (that.tenderTypeActive == "second") {
        this.getZtbTenderList(); //加载中标列表
      } else if (that.tenderTypeActive == "third") {
        this.getZtbTenderList(); //加载招标列表
      }
    },

    /**
     * 每页显示的条数改变，刷新列表
     */
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      var that = this;
      that.pageSize = val;
      if (that.tenderTypeActive == "first") {
        this.getBigTenderList(); //加载近期大标列表
      } else if (that.tenderTypeActive == "second") {
        this.getZtbTenderList(); //加载中标列表
      } else if (that.tenderTypeActive == "third") {
        this.getZtbTenderList(); //加载招标列表
      }
    },

    /**
     * 获取通信、电力折线图柱状图数据
     */
    getLineEchart: function ({ name, type, elemId, pieId }) {
      var that = this;
      //调用外部引入的js先声明再调用
      let thatLineEchart = lineEchart;
      let thatPieEchart = pieEchart;
      that.requestApi({
        method: "get",
        url: "/api/project/statistics",
        data: {
          type: type
        },
        then(data) {
          if (data.data != null) {
            that.echartList[name] = data.data;
            let monthArray = new Array(); //x轴：月份
            let monthCountArray = new Array(); //y轴：月份对应的标讯数据
            let monthTotalMoneyArray = new Array(); //y轴：月份对应的标讯金额
            let monthList = data.data.monthDataList; //后台返回的数据数组

            for (let i = 0; i < monthList.length; i++) {
              monthArray.push(monthList[i].month); //取出后台返回的数据数组里面的月份
              monthCountArray.push(monthList[i].count); //取出后台返回的数据数组里面的标讯数据
              monthTotalMoneyArray.push(monthList[i].totalMoney); //取出后台返回的数据数组里面的标讯金额

              //数据分析的开始结束时间
              var monthMax = monthList.length - 1;
              if (type == 1) {
                //通信
                that.startTime = monthList[0].month; //统计的开始时间
                that.endTime = monthList[monthMax].month; //统计的结束时间
              } else if (type == 2) {
                //电力
                that.dianLiStartTime = monthList[0].month;
                that.dianLiEndTime = monthList[monthMax].month;
              } else if (type == 3) {
                //政府
                that.governmentStartTime = monthList[0].month;
                that.governmentEndTime = monthList[monthMax].month;
              }
            }

            //运营商
            if (type == 1) {
              that.indexPieList = data.data.operatorDataList; //通信
            } else if (type == 2) {
              that.dainLiPieList = data.data.operatorDataList; //电力
            } else if (type == 3) {
              that.governmentPieList = data.data.operatorDataList; //电力
            }

            let operatorMoney = new Array(); //运营商项目金额
            let operatorList = data.data.operatorDataList; //后台返回的数据数组
            let operatorAarry = new Array();

            //饼状图（要统计数据的数量，要统计数据的名称）
            for (let i = 0; i < operatorList.length; i++) {
              operatorAarry.push({
                value: operatorList[i].totalMoney, //项目的总金额
                name: operatorList[i].name //运营商的名称
              });
            }
            console.log("222:" + operatorMoney);

            //调用折线图柱状图混合js
            thatLineEchart({
              idName: elemId, //动态id名称，调用的时候传入用来区分通信、电力
              dataArray: monthArray, //柱状图、折线图的横坐标，月份
              //柱状图、折线图的纵坐标（要统计的数量）
              xyAxisArray: [
                {
                  name: "总数",
                  type: "bar", //柱状图
                  barWidth: 15, //柱状图的宽度
                  color: "#268AA6",
                  data: monthCountArray //柱状图纵坐标的数据，统计标讯数据
                },
                {
                  name: "金额",
                  type: "line",
                  barWidth: 15,
                  yAxisIndex: 1,
                  color: "#F69C4D",
                  data: monthTotalMoneyArray //折线图纵坐标的数据，统计标讯金额
                }
              ],
              _this: that
            });

            //调用饼状图js
            thatPieEchart({
              idName: pieId, //动态id名称，调用的时候传入用来区分通信、电力
              colorArray: [
                "#268AA6",
                "#5E8DDD",
                "#32B0D3",
                "#37CCC3",
                "#BCBCBC"
              ], //饼状图的颜色，用来区分不同的运营商
              pieRadius: ["50%", "70%"], //饼状图的类型
              roseType: "",
              labelSet: {
                normal: {
                  show: false,
                  position: "center"
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: "30",
                    fontWeight: "bold"
                  }
                }
              },
              xyAxisArray: operatorAarry,//统计的数据（统计的是运营商的项目总金额）
              _this: that,
              sourceList: data.data.operatorDataList
            });
          }
        }
      });
    },

    /**
     * 获取首页广告图
     */
    getIndexBannerUrl: function () {
      var that = this;
      that.requestApi({
        method: "get",
        url: "/api/advertising/getIndexAdvertisingImg",
        data: {},
        then(data) {
          if (data.data && data.data.length > 0) {
            console.log("banner:" + data.data[0].imgUuid);
            that.bannerImgShow = true; //是否显示banner图，如果数据为空，则将banner图隐藏
            var tempData = data.data;
            if (tempData.length > 0) {
              that.bannerImgLink = tempData[0].url; //点击banner图跳转的链接
              /* that.bannerImgUrl =
                that.$root.apiUrl +
                that.$root.cntextPath +
                "/api/rawImgByUUID?uuid=" +
                tempData[0].imgUuid; //banner图的链接，用来显示banner图 */
              that.bannerImgUrl = tempData[0].imgUuid.url; //banner图的链接，用来显示banner图
            }
          } else {
            that.bannerImgShow = false;
          }
        }
      });
    },

    /**
     * 获取业务类型
     */
    getBusType: function () {
      var that = this;
      that.requestApi({
        method: "get",
        url: "/api/ztb/projectBusinessType/projectBusinessTypeJson",
        then(data) {
          var businessType = JSON.parse(data.data);
          for (var i = 0; i < businessType.length; i++) {
            var bus = businessType[i];
            bus.id = i;
            bus.state = 0;
            var list = bus.list;
            if (list != null && list.length > 0) {
              for (var j = 0; j < list.length; j++) {
                var item = list[j];
                item.id = j;
                item.state = 0;
                list[j] = item;
                item.parentId = bus.id;
                item.parentIndex = i;
              }
              var all = {
                id: 0,
                name: "不限",
                state: 0,
                all: 1,
                parentId: bus.id,
                parentIndex: i
              };
              list.unshift(all);
              bus.list = list;
            }
          }
          that.businessType = businessType;
        }
      });
    },

    /**
     * 获取政府业务分类
     */
    getJobTag: function () {
      var that = this;

      that.requestApi({
        method: "get",
        url: "/api/ztb/projectBusinessType/govProjectBusinessTypeJson",
        then(res) {
          console.log(res);
          if (res.data) {
            var businessType = JSON.parse(res.data);
            for (var i = 0; i < businessType.length; i++) {
              var bus = businessType[i];
              bus.id = i;
              bus.state = 0;
              var list = bus.list;
              if (list != null && list.length > 0) {
                for (var j = 0; j < list.length; j++) {
                  var item = list[j];
                  item.id = j;
                  item.state = 0;
                  list[j] = item;
                  item.parentId = bus.id;
                  item.parentIndex = i;
                }
                var all = {
                  id: 0,
                  name: "不限",
                  state: 0,
                  all: 1,
                  parentId: bus.id,
                  parentIndex: i
                };
                list.unshift(all);
                bus.list = list;
              }
            }
            that.jobType = businessType
          }

        }
      });



      var searchTenderJobTagArray = this.$root.searchTenderJobTagArray;
      if (searchTenderJobTagArray != null) {
        this.jobTabType = searchTenderJobTagArray;
      } else {
        that.requestApi({
          method: "get",
          url: "/api/project/dataLabelsJobTag/getJobTagJson",
          then(data) {
            var list = JSON.parse(data.data);
            var jobTab = [];
            for (var i = 0; i < list.length; i++) {
              var tab = {
                id: i + 1,
                name: list[i],
                state: 0
              };
              jobTab.push(tab);
            }
            var all = {
              id: 0,
              name: "不限",
              state: 0,
              all: 1
            };
            jobTab.unshift(all);
            that.jobTabType = jobTab;
          }
        });
      }
    },

    //获取电力业务分类
    getBusTypeNew: function () {
      var that = this;
      this.requestApi({
        url: "/api/ztb/projectBusinessType/getBusinessTypeJsonByGuildId",
        method: "get",
        data: { guildId: 2 },
        then: function (res) {
          var businessType = JSON.parse(res.data);
          for (var i = 0; i < businessType.length; i++) {
            var bus = businessType[i];
            bus.id = i;
            bus.state = 0;
            var list = bus.list;
            if (list != null && list.length > 0) {
              for (var j = 0; j < list.length; j++) {
                var item = list[j];
                item.id = j;
                item.state = 0;
                list[j] = item;
                item.parentId = bus.id;
                item.parentIndex = i;
              }
              var all = {
                id: 0,
                name: "不限",
                state: 0,
                all: 1,
                parentId: bus.id,
                parentIndex: i
              };
              list.unshift(all);
              bus.list = list;
            }
          }
          that.electricityType = businessType;
        }
      });
    },

    // 选择：通信、政府：1/2
    typeChoose(type, index) {
      var that = this;
      var data;
      if (that.isLogin == true) {
        var ewmLogin = that.$refs.ewmLogin;
        if (ewmLogin != null) {
          ewmLogin.showLogin();
        }
        return;
      }
      console.log("type:" + type);

      var industryType = that.industryType;

      switch (type) {
        //通信
        case 1:
          data = this.businessType;
          data[index].state = 1;
          var list = data[index].list;
          for (var i = 0; i < list.length; i++) {
            list[i].state = 1;
          }
          data[index].list = list;
          this.$root.searchTenderBusinessTypeArray = data;
          industryType[0].state = 1;
          industryType[1].state = 0;
          industryType[2].state = 0;
          this.$root.searchTenderGuildIdArray = industryType;
          break;

        //电力
        case 2:
          data = this.electricityType;
          data[index].state = 1;
          var list = data[index].list;
          for (var i = 0; i < list.length; i++) {
            list[i].state = 1;
          }
          data[index].list = list;
          this.$root.searchTenderBusinessTypeArray = data;
          industryType[0].state = 0;
          industryType[1].state = 1;
          industryType[2].state = 0;
          this.$root.searchTenderGuildIdArray = industryType;
          break;

        //政府
        case 3://此处为政府类型下的标签，因政府职能标签无法作为搜索条件所以暂时隐藏  v-show="false"
          data = this.jobType;
          data[index].state = 1;
          var list = data[index].list;
          for (var i = 0; i < list.length; i++) {
            list[i].state = 1;
          }
          data[index].list = list;
          this.$root.searchTenderBusinessTypeArray = data;
          industryType[0].state = 0;
          industryType[1].state = 0;
          industryType[2].state = 1;
          this.$root.searchTenderGuildIdArray = industryType;
          break;

        /* //政府
         case 3://此处为政府类型下的标签，因政府职能标签无法作为搜索条件所以暂时隐藏  v-show="false"
           data = this.jobTabType;
           data[index].state = 1;
           this.$root.searchTenderGuildIdArray = this.industryType;
           this.$root.searchTenderJobTagArray = data;
           industryType[0].state = 0;
           industryType[1].state = 0;
           industryType[2].state = 1;
           this.$root.searchTenderGuildIdArray = industryType;
           break; */
      }
      this.$router.push({
        path: "/tender/search",
        query: { dataObj: "" }
      });
    },
    getUserInfo() {
      let that = this;
      that.requestApi({
        method: "get",
        url: "/api/user/userInfo",
        loginStatus(res, status) {
          //that.isLogin = true; //二维码登录的状态
          that.$refs.headerBar.loginBtnShow = true;
          console.log("status:", status);
          that.indexBgShow = status;
        },
        then(data) {
          if (data.data != null) {
            that.indexBgShow = false;
            var headerBar = that.$refs.headerBar;
            headerBar.getUserMsg();
            headerBar.isBindPhone();
          }

          that.requestApi({
            method: "get",
            url: "/api/promotionPopup/popup",
            then(res) {
              if (res.data == 5) {
                that.visibleHui = true

                that.requestApi({
                  method: "get",
                  url: "/api/config/getValue",
                  data: { name: 'guoqihuiyuanyouhuiquan', project: 'uxsq' },
                  then(idListRes) {
                    // console.log(idListRes.data);
                    // 是否领取过
                    that.requestApi({
                      method: "get",
                      url: "/api/promotionPopup/usePopupByEncryptedText",
                      data: { encryptedText: idListRes.data },
                      then(res) {
                      }
                    })
                  }
                })
              }
            }
          })


        }
      });
    },
    goLogin() {
      var that = this;
      that.isLogin = true; //二维码登录的状态
      var ewmLogin = that.$refs.ewmLogin;
      if (ewmLogin != null) {
        ewmLogin.showLogin();
      }
      return;
    }
    // isShowBusinessSub() {
    //   let that = this;
    //   that.requestApi({
    //     method: "get",
    //     url: "/api/user/userTag/hasUserTag",
    //     then(data) {
    //       if (data.data != null) {
    //         that.showBusinessSub = !data.data;
    //       }
    //     }
    //   });
    // }
  },

  /**
   * 在模板渲染成html前调用，即通常初始化某些属性值，然后再渲染成视图。
   */
  created(data) {
    var that = this;
    let restLogin = new pageParam().getUrlKey("restLogin");
    // this.restLogin = this.$route.query;
    if (restLogin === "true") {
      window.document.cookie = "";
      // 帐号在其他地方登陆，被T下线
      var content =
        "您的账号在另一设备登陆，您被迫下线。如果这不是您本人的操作，您的密码可能已经泄露。建议您修改密码。";
      this.$alert(content, "账号警告", {
        confirmButtonText: "确定",
        callback: action => {
          var ewmLogin = that.$refs.ewmLogin;
          if (ewmLogin != null) {
            ewmLogin.showLogin();
          }
          // location.href = location.origin + location.pathname + "#/index";
          // this.$router.push({
          //   path: "/index"
          // });
        }
      });
    } else {
      that.getUserInfo();
    }

    this.getBusType(); //获取业务类型
    this.getJobTag(); //获取政府职能标签
    this.getBusTypeNew(); //获取电力业务分类
    this.getRecommendTenderList(); //获取推荐标讯列表
    this.getHotQueryKeyword(); //获取热门搜索关键字
    this.getBigTenderList(); //获取近期大标列表
  },

  /**
   * 模板渲染成html后调用
   */
  mounted() {
    //搜索次数上限了
    if (this.$route.params.getInfoByInfoVOKey === -2) {//搜索次数上限了
      this.$refs.headerBar.isVipMember();
    }
    //搜索次数上限了 end
    var that = this;
    that.getIndexBannerUrl(); //获取首页banner图
    //that.isShowBusinessSub();  //业务订阅

    // 这个延迟不能去掉
    setTimeout(function () {
      //通信数据分析
      var data = that.getLineEchart({
        name: "tongxin",
        type: 1,
        elemId: "indexLineEchart_tongxin", //折线图柱状图id
        pieId: "indexPieEchart_tongxin" //饼状图id
      });
      //电力数据分析
      data = that.getLineEchart({
        name: "dianli",
        type: 2,
        elemId: "indexLineEchart_dianli",
        pieId: "indexPieEchart_dianli"
      });
      //政府数据分析
      data = that.getLineEchart({
        name: "government",
        type: 3,
        elemId: "indexLineEchart_government",
        pieId: "indexPieEchart_government"
      });
    }, 100);
    console.log('data357');
    setTimeout(() => {
      console.log('data358');
      let ret = that.axios.get("/bid/api/user/userInfo").then(ret => {
        console.log('data35', ret);
        if (ret.data.code == -1001) {
          console.log('data359', ret.data);
          that.$message({
            message: "请先登录",
            type: "error"
          });
        }
      })
    }, 2000)
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.indexBg {
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  z-index: 900;
}

.tipsCon>span {
  color: #ff0000;
}

/deep/ .visibleHui .el-dialog {
  background: transparent;
  box-shadow: none;
}

/deep/ .visibleHui .el-dialog__headerbtn .el-dialog__close {
  transform: scale(1.7);
}
</style>



// WEBPACK FOOTER //
// src/page/index.vue